<app-tool-loader [isLoading]="isLoading()" [positionUnset]="true">

  <p-toolbar>
    <ng-template #start>
      <div class="toolbar-menu">
        @if (!isLoading()) {
          <app-units-select-input appendTo="body" [options]="stringSections"
            [(ngModel)]="selectedStringSection" optionLabel="label" optionValue="label"
            [optionLabelFormatter]="formatStringSectionOption"
            ariaLabel="Design limits string section"
            (onChange)="selectedStringSectionUpdated($event, $event.originalEvent)"></app-units-select-input>
        }
      </div>
    </ng-template>
  </p-toolbar>

    <app-xy-line-plot [plotData]="plot.data" [xAxisTitle]="xAxisTitle" [yAxisTitle]="yAxisTitle" [plotName]="plotName"
      [plotTitle]="'Design Limits Plot'" [reverseAutoRange]="true" [downloadPlotName]="downloadPlotName"
      [plotOrientation]="''" [xyLinePlotStore]="designLimitsPlotStore"
    ></app-xy-line-plot>
  @if (!isLoading()) {
    <p-dialog [draggable]="false" [visible]="isDialogVisible" [closable]="false" appendTo="self">
      @if (needToCalculate) {
        <div>
          <i class="pi pi-exclamation-circle pr-1"></i> <label>Please calculate PERIVIS to see results.</label>
        </div>
      }
      @if (configMissing) {
        <div>
          <i class="pi pi-exclamation-circle pr-1"></i> <label>Well Configuration Missing: Please specify at least one string.</label>
        </div>
      }
      <br />
    </p-dialog>
  }

  @if (dlpData) {
    <app-perivis-validation [errors]="dlpData?.errors" />
  }

</app-tool-loader>